"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorForGrid = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_chartjs_2_1 = require("react-chartjs-2");
var chart_js_1 = require("chart.js");
var GraphHeader_1 = __importDefault(require("./GraphHeader"));
var graph_1 = require("../../utils/graph");
var graphTooltip_1 = require("../../utils/graphTooltip");
var GraphTooltip_1 = __importDefault(require("./GraphTooltip"));
var graphPlugins_1 = require("../../utils/graphPlugins");
chart_js_1.Chart.register(chart_js_1.CategoryScale, chart_js_1.LinearScale, chart_js_1.PointElement, chart_js_1.LineElement, chart_js_1.Title, chart_js_1.Tooltip);
var getColorForGrid = function (ctx) { return ctx.index === 0 ? '#b3b3b3' : '#e5e5e5'; };
exports.getColorForGrid = getColorForGrid;
var LineGraph = function (_a) {
    var _b = _a.legend, legend = _b === void 0 ? true : _b, labels = _a.labels, dataSets = _a.dataSets, comparisonDataSets = _a.comparisonDataSets, leftAxisLabel = _a.leftAxisLabel, rightAxisLabel = _a.rightAxisLabel, toggleViewLabel = _a.toggleViewLabel, _c = _a.defaultViewLabel, defaultViewLabel = _c === void 0 ? 'Default' : _c, _d = _a.comparisonViewLabel, comparisonViewLabel = _d === void 0 ? 'Comparison' : _d, hideHorizontalLabel = _a.hideHorizontalLabel, _e = _a.aspectRatio, aspectRatio = _e === void 0 ? 2 : _e, className = _a.className;
    var _f = __read((0, react_1.useState)('default'), 2), view = _f[0], setView = _f[1];
    var hasComparison = !!(comparisonDataSets === null || comparisonDataSets === void 0 ? void 0 : comparisonDataSets.length);
    var builtDataSets = hasComparison && view === 'comparison' ? __spreadArray(__spreadArray([], __read((0, graph_1.buildDataSets)(dataSets, false)), false), __read((0, graph_1.buildDataSets)(comparisonDataSets, true)), false) : (0, graph_1.buildDataSets)(dataSets, false);
    var views = (comparisonDataSets === null || comparisonDataSets === void 0 ? void 0 : comparisonDataSets.length) ? [
        { id: 'default', label: defaultViewLabel, active: view === 'default' },
        { id: 'comparison', label: comparisonViewLabel, active: view === 'comparison' },
    ] : [];
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-graph ui-line-graph", className) },
        react_1.default.createElement(GraphTooltip_1.default, null),
        react_1.default.createElement(GraphHeader_1.default, { views: views, onViewChange: function (v) { return setView(v); }, legend: legend, toggleViewLabel: toggleViewLabel, dataSets: dataSets, comparisonDataSets: view === 'comparison' ? comparisonDataSets : undefined }),
        (leftAxisLabel || rightAxisLabel) ? (react_1.default.createElement("div", { className: "ui-line-graph-axis-labels" },
            react_1.default.createElement("span", null, leftAxisLabel),
            react_1.default.createElement("span", null, rightAxisLabel))) : null,
        react_1.default.createElement(react_chartjs_2_1.Line, { options: {
                aspectRatio: aspectRatio,
                responsive: true,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                plugins: {
                    legend: {
                        display: false,
                    },
                    title: {
                        display: false,
                    },
                    tooltip: {
                        enabled: false,
                        mode: 'index',
                        position: 'custom',
                        external: graphTooltip_1.configureGraphTooltip,
                    },
                },
                scales: {
                    left: {
                        type: 'linear',
                        display: dataSets.some(function (d) { return d.side !== 'right'; }),
                        position: 'left',
                        grid: {
                            borderDash: [4],
                            color: exports.getColorForGrid,
                        },
                        ticks: {
                            crossAlign: 'far',
                            color: '#666666',
                        },
                    },
                    right: {
                        type: 'linear',
                        display: dataSets.some(function (d) { return d.side === 'right'; }),
                        position: 'right',
                        grid: {
                            drawOnChartArea: false,
                        },
                        ticks: {
                            crossAlign: 'far',
                            color: '#666666',
                        },
                    },
                    xAxes: {
                        display: !hideHorizontalLabel,
                        grid: {
                            borderDash: [4],
                            color: exports.getColorForGrid,
                        },
                        ticks: {
                            color: '#666666',
                        },
                    },
                },
            }, data: {
                labels: labels,
                datasets: builtDataSets,
            }, plugins: [
                graphPlugins_1.verticalLinePlugin,
                graphPlugins_1.videoSyncPlugin,
            ] })));
};
exports.default = LineGraph;
